const radius = {
  default: '1rem',
  micro: '.3rem',
  small: '.5rem',
  medium: '.8rem',
  big: '2rem',
  round: '50%',
}

export default radius;
export {radius}
